import SortAscendingIcon from './component'

export default SortAscendingIcon
